import React, { forwardRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Card } from 'react-bootstrap';
import { PLAN_TYPE_LIST } from '../../../constants';
import { setPlanTypeTypeId, setWorkedRangeType } from '../../../actions/farm-monitor';
import PlanTypeSelection from './PlanTypeSelection';
import FbPost from '../../widgets/FbPost';
import { getCloneFarmChartElement, getComponentAsBlob } from '../../../helpers/fileConverter';
import { getDateRange } from '../../../helpers/common';
import { SummaryToggle } from './SummaryToggle';
import { ToggleSwitch } from '../../widgets';

const SummaryHeader = forwardRef((props, farmRef) => {
    const { selectedPlanTypeId, analyseDetails, fieldLoadsById, farmName, search: { range, custom, customRange },
        summaryToggleCollapsed, isDataUntilNow, isRequestingWorkedAcres, isRequestingEGWorkedAcres } = props;
    const handlePlanType = (id) => props.actions.setPlanTypeTypeId(id);

    const { summary, elasticWork, elasticLoad } = analyseDetails;

    const chartName = 'Farm - Worked acres';

    const isPageLoading = (elasticWork && elasticWork.isRequesting)
        || (summary && summary.isRequesting)
        || (elasticLoad && elasticLoad.isRequesting)
        || (fieldLoadsById && fieldLoadsById.isRequesting);
    const isFieldLoading = isPageLoading || isRequestingEGWorkedAcres || isRequestingWorkedAcres;

    const dateRange = getDateRange({ custom, range, customRange });
    const postDescription = `${dateRange.name}${dateRange.range ? ` - ${dateRange.range}` : ''}`;
    const getImageUrl = async () => {
        const clonedElement = getCloneFarmChartElement(farmRef.current);
        return await getComponentAsBlob(clonedElement);
    }

    return <Card.Header className="worked-details-header">
        <Row className="m-0 h-100 align-items-center">
            <Col className="p-0 m-auto d-flex align-items-center">
                <div className="title">{chartName}</div>
                {!summaryToggleCollapsed && <FbPost
                    getImageUrl={getImageUrl}
                    isLoading={isPageLoading}
                    chartName={chartName}
                    title={farmName}
                    description={postDescription} />}
            </Col>
            <Col>
                <div className="d-flex align-items-center justify-content-end">
                    <div>

                        <div className="fm-toggle toggle-switch float-right d-flex align-items-center">
                            <span className="label mr-2 mb-1">Until now</span>
                            <ToggleSwitch
                                disabled={isFieldLoading}
                                onChange={(e) => {
                                    props.actions.setWorkedRangeType(e.target.checked);
                                }}
                                checked={isDataUntilNow}
                            />
                        </div>
                    </div>
                    <div className="p-0 ml-5 mr-3">
                        <div className="avatar-item">
                            <PlanTypeSelection activePlanType={selectedPlanTypeId} handlePlanType={handlePlanType} planTypeList={PLAN_TYPE_LIST} />
                        </div>
                    </div>
                    <div md="auto" className="d-flex align-items-center">
                        <SummaryToggle isRequesting={isPageLoading} eventKey="0" />
                    </div>
                </div>
            </Col>
        </Row>
    </Card.Header>
});

const mapStateToProps = (state, ownProps) => {
    const selectedPlanTypeId = state.farmMonitor.selectedPlanTypeId;
    return {
        farmName: state.farm.currentFarm.farm_name,
        selectedPlanTypeId,
        isDataUntilNow: state.farmMonitor.isDataUntilNow,
        analyseDetails: state.farmMonitor.summaryByPlanTypeId[selectedPlanTypeId] ? state.farmMonitor.summaryByPlanTypeId[selectedPlanTypeId] : {},
        fieldLoadsById: state.farmMonitor.fieldLoadsById,
        summaryToggleCollapsed: state.farmMonitor.summaryToggleCollapsed,
        isRequestingEGWorkedAcres: state.farmMonitor.workedById.isRequestingWorkedEG,
        isRequestingWorkedAcres: state.farmMonitor.workedById.isRequesting,
        search: {
            customRange: state.analyze.searchParams.customRange,
            range: state.analyze.searchParams.range,
            custom: state.analyze.searchParams.custom
        }
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        setPlanTypeTypeId,
        setWorkedRangeType
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(SummaryHeader);